import {AfterViewInit, Component, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpCommonService} from "../../services/http-common.service";

import '../../../assets/plugins/echarts/dist/echarts2.js';
import {EnterpAtlasService} from "../../services/enterp-atlas.service";
declare var echartsEC: any;
declare var requireEC: any;
/**
 * 股权结构
 */
@Component({
  selector: 'app-enter-stockright-structure',
  templateUrl: './enter-stockright-structure.component.html',
  styleUrls: ['./enter-stockright-structure.component.css']
})
export class EnterStockrightStructureComponent implements OnInit, AfterViewInit {

  // myChartGuQ: any;
  // optionGuQ: any;
  // Text  = requireEC('zrender/shape/Text');
  rootDataGuQ: any;
  //传递的参数 企业ID
  companyId: string;
  constructor(private routerInfo: ActivatedRoute, private httpService: HttpCommonService,
              private enterpAltasService: EnterpAtlasService) {
    this.companyId = routerInfo.snapshot.queryParams['companyId'];
    // this.companyId = '00001e0dc8082237c287be3db76761ca';
  }

  ngOnInit() {
    // this.getGuQuanData();
  }
  //获取股权数据
  getGuQuanData(){
    // this.myChartGuQ = echartsEC.init(document.getElementById('stockRight'));
    this.httpService.get('/enterprise/detail/xhsRest/enterMap/getGUQuanDatas',
      {companyId: this.companyId}).subscribe(data => {
      //console.log(data);
      this.rootDataGuQ = data.Result;
      // this.transTree(this.rootDataGuQ);
      // this.initTree(this.rootDataGuQ);
      // this.drawStockRight(this.rootDataGuQ);
    });
    // let dataGQ = this.enterpAltasService.getEnterGQ();
    // this.rootDataGuQ = dataGQ.Result;
    // this.transTree(this.rootDataGuQ);
    // this.initTree(this.rootDataGuQ);
    // this.drawStockRight(this.rootDataGuQ);
  }

  ngAfterViewInit() {
    var thiss = this;
    var myChartGuQ;
    var Text  = requireEC('zrender/shape/Text');
    var rootDataGuQ;
    var optionGuQ;
    //传递的参数 企业ID
    var companyId = this.companyId;
    $(function(){
      if (companyId) {
        myChartGuQ = echartsEC.init(document.getElementById('stockRight'));
        thiss.httpService.get("/enterprise/detail/xhsRest/baseMsg/getCompanyInfo",
          {"companyId": thiss.companyId}).subscribe(data => {
          if(data.data.returnData!=null){
            let companyName = data.data.returnData[0].name;
            thiss.httpService.get('/enterprise/detail/xhsRest/enterMap/getGUQuanDatasByQcc',
              {companyName: companyName}).subscribe(result => {
              console.log(result);
              if (result.stateCode == "60601") {
                rootDataGuQ = result.data.Result;
                companyId = result.data.Result.KeyNo;
                transTree(rootDataGuQ);
                initTree(rootDataGuQ);
                drawStockRight(rootDataGuQ);
              }
            });
          }
        });
      }
    });
    function transTree(data){
      data.children = data.Children;
      data.Children = undefined;
      data.name = data.Name.replace(/(.{5})(?=.)/g, '$1\n');;
      var  children = data.children;
      if(!children){
        data.symbol = 'circle';
        data.symbolSize= [30, 30],
          data.labelClick = true;
        data.itemStyle =  {
          normal: {
            color: "#40bfd5",
            borderWidth: "4",
            borderColor: "#E8E8E8",
            label: {
              show: false,
              position: "right",
              textStyle: {
                fontFamily: "MicroSoft YaHei",
                fontSize: 14,
                color:'#666',
                fontStyle: "normal",
              },
            }
          },
          emphasis: {
            color: "#40bfd5",
            borderWidth: "2",
            borderColor: "#E8E8E8",
          }
        };
      }else{
        data.symbol = 'circleCross';
        data.symbolSize= [30, 30],
          data.labelClick = true;
        data.itemStyle =  {
          normal: {
            color: "#40bfd5",
            borderWidth: "6",
            borderColor: "#E8E8E8",
            label: {
              show: false,
              position: "right",
              textStyle: {
                fontFamily: "MicroSoft YaHei",
                fontSize: 14,
                color:'#666',
                fontStyle: "normal",
              },
            }
          },
          emphasis: {
            color: "#40bfd5",
            borderWidth: "4",
            borderColor: "#E8E8E8",
          }
        };
        for(var i=0;i<children.length;i++){
          transTree(children[i]);
          var tamp = children[i];
          var Ratio = children[i].FundedRatio || '';
          if(Ratio){
            Ratio = ((children[i].FundedRatio.substr(0,children[i].FundedRatio.length-1)*10000/10000).toFixed(4))+'%';
          }
          children[i] = {
            name:Ratio,
            symbol: "arrowdown",
            symbolSize: [12, 12],
            tooltip: {
              show: !1
            },
            clickable: !1,
            itemStyle: {
              normal: {
                color: "#999",
                label: {
                  show: !0,
                  position: "right",
                  textStyle: {
                    fontFamily: "MicroSoft YaHei",
                    fontSize: 14,
                    fontStyle: "normal",
                  },
                }
              },
              emphasis: {
                color: "#999",
                label: {
                  show: !0,
                  position: "right",
                  textStyle: {
                    fontFamily: "MicroSoft YaHei",
                    fontSize: 14,
                    fontStyle: "normal",
                  },
                }
              }
            },
            lineStyle: {
              width: 1,
              color: "#E8E8E8"
            },
            children:[tamp]
          }
        }
      }
      if(data.Category==2){
        data.symbol = 'rectangle';
        data.clickable = false;
        data.labelClick = false;
        data.symbolSize= [30, 30],
          data.itemStyle =  {
            normal: {
              color: "#6c89cb",
              borderWidth: "4",
              borderColor: "#E8E8E8",
              label: {
                show: !0,
                position: "right",
                textStyle: {
                  color:'#666',
                  fontFamily: "MicroSoft YaHei",
                  fontSize: 14,
                  fontStyle: "normal",
                },
              }
            },
            emphasis: {
              color: "#6c89cb",
              borderWidth: "2",
              borderColor: "#E8E8E8",
            }
          };
      }
    }
    //初始化树状
    function initTree(data){
      data.name = data.Name;
      data.labelClick = false;
      data.symbolSize = [60, 60];
      data.symbol = 'circle';
      data.itemStyle =  {
        normal: {
          color: "#40bfd5",
          borderWidth: "5",
          borderColor: "#E8E8E8",
          label: {
            show: !0,
            position: "right",
            textStyle: {
              fontFamily: "MicroSoft YaHei",
              fontSize: 14,
              fontStyle: "normal",
            },
          }
        },
        emphasis: {
          color: "#40bfd5",
          borderWidth: "3",
          borderColor: "#E8E8E8",
        }
      };
      getNode(rootDataGuQ);
      function getNode(data){
        if(data.children){
          for(var i=0;i<data.children.length;i++){
            getNode(data.children[i]);
          }
        }
        if(data.children && data.KeyNo && data.KeyNo != companyId){
          data._children = data.children;
          data.children = null;
          data.symbol = 'circleCross';
        }
      }
    }
    //股权结构图
    function drawStockRight(rootDataGuQ){
      optionGuQ = {
        title : {
          text: '',
        },
        series : [
          {
            type: "tree",
            orient: "vertical",
            nodePadding: 100,
            layerPadding: 50,
            symbol:  "circle",
            roam: true,
            rootLocation: {
              "x": "48%",
              "y": "65%"
            },
            direction:"inverse",
            data: [rootDataGuQ]
          }
        ]
      };
      myChartGuQ.setOption(optionGuQ);
      initGuQZrender();
      animatieChart(myChartGuQ,0,0);
      var ecConfig = requireEC('echartsEC/config');
      myChartGuQ.on(ecConfig.EVENT.CLICK, function(e){
        if(e.data.Category==1 && e.data.KeyNo){
          if(e.data.children||e.data._children){
            troggleTree(e.data.KeyNo);
          }
        }
      });
      myChartGuQ.on(ecConfig.EVENT.RESTORE, function(param){
        getNode(rootDataGuQ);
        function getNode(data){
          if(data.children){
            for(var i=0;i<data.children.length;i++){
              getNode(data.children[i]);
            }
          }
          if(data.children && data.KeyNo && data.KeyNo != companyId){
            data._children = data.children;
            data.children = null;
            data.symbol = 'circleCross';
          }
        }
        initGuQZrender();
        animatieChart(myChartGuQ,0,0);
      });
// 	window.onresize=function(){
//    		myChartGuQ.resize();
//    	}
    }
    function initGuQZrender(){
      var shapeList = myChartGuQ.getZrender().storage.getShapeList();
      for(var i=0;i<shapeList.length;i++){
        if(shapeList[i].clickcom){
          myChartGuQ.getZrender().delShape(shapeList[i].id);
        }
      }
      for(var i=0;i<shapeList.length;i++){
        if(shapeList[i]._echartsData&&shapeList[i]._echartsData._data.labelClick){
          var shape = new Text({
            style: {
              x: shapeList[i].rotation[1]+25,
              y: shapeList[i].rotation[2],
              text: shapeList[i]._echartsData._name,
              color : '#333' ,
              textFont:'normal 13px 微软雅黑',
              lineWidth :0,
            },
            highlightStyle : {
              lineWidth :0,
              strokeColor:'rgba(0,0,0,0)',
            }
          });
          shape.keyNo = shapeList[i]._echartsData._data.KeyNo;
          shape.zlevel = 1;
          shape.z = 4;
          shape.clickcom = true;
          shape.clickable = true;
          myChartGuQ.getZrender().addShape(shape);
        }
      }
    }

    function troggleTree(KeyNo){
      if(KeyNo == companyId){
        return;
      }
      getNode(rootDataGuQ);
      function getNode(data){
        if(data.KeyNo&&data.KeyNo==KeyNo){
          if(data.children){
            data._children = data.children;
            data.children = null;
            data.symbol = 'circleCross';
          }else if(data._children){
            data.children = data._children;
            data._children = null;
            data.symbol = 'circleMinus';
          }
          return;
        }
        if(data.children){
          for(var i=0;i<data.children.length;i++){
            getNode(data.children[i]);
          }
        }
      }
      myChartGuQ.clear();
      myChartGuQ.setOption(optionGuQ);
      initGuQZrender();
    }
    function animatieChart(myChart,targetX,targetY){
      var centerX = myChart.getZrender().getWidth()/2;
      var centerY = myChart.getZrender().getHeight()/2;
      var layer = myChart.getZrender().painter._layers[1];
      var animation = myChart.getZrender().animation;
      layer.scale = [0.2,0.2,centerX,centerY];
      layer.rotation = [0,centerX,centerY];
      layer.position = [targetX||0,targetY||0];
      myChart.getZrender().render();
      animation.animate(layer).when(400, {
        scale: [1,1,centerX,centerY]
      }).start('spline').done(function(){
        layer.scale[2] = 0;
        layer.scale[3] = 0;
      }).during(function(){
        myChart.getZrender().render();
      });
    }
  }
  /*
  //处理树
  transTree(data){
    data.children = data.Children;
    data.Children = undefined;
    data.name = data.Name.replace(/(.{5})(?=.)/g, '$1\n');;
    let children = data.children;
    if(!children){
      data.symbol = 'circle';
      data.symbolSize= [30, 30],
      data.labelClick = true;
      data.itemStyle =  {
        normal: {
          color: "#40bfd5",
          borderWidth: "4",
          borderColor: "#E8E8E8",
          label: {
            show: false,
            position: "right",
            textStyle: {
              fontFamily: "MicroSoft YaHei",
              fontSize: 14,
              color:'#666',
              fontStyle: "normal",
            },
          }
        },
        emphasis: {
          color: "#40bfd5",
          borderWidth: "2",
          borderColor: "#E8E8E8",
        }
      };
    }else{
      data.symbol = 'circleCross';
      data.symbolSize= [30, 30],
      data.labelClick = true;
      data.itemStyle =  {
        normal: {
          color: "#40bfd5",
          borderWidth: "6",
          borderColor: "#E8E8E8",
          label: {
            show: false,
            position: "right",
            textStyle: {
              fontFamily: "MicroSoft YaHei",
              fontSize: 14,
              color:'#666',
              fontStyle: "normal",
            },
          }
        },
        emphasis: {
          color: "#40bfd5",
          borderWidth: "4",
          borderColor: "#E8E8E8",
        }
      };
      for(let i=0;i<children.length;i++){
        this.transTree(children[i]);
        let tamp = children[i];
        let Ratio = children[i].FundedRatio || '';
        if(Ratio){
          Ratio = ((children[i].FundedRatio.substr(0,children[i].FundedRatio.length-1))*10000/10000).toFixed(4)+'%'
        }
        children[i] = {
          name:Ratio,
          symbol: "arrowdown",
          symbolSize: [12, 12],
          tooltip: {
            show: !1
          },
          clickable: !1,
          itemStyle: {
            normal: {
              color: "#999",
              label: {
                show: !0,
                position: "right",
                textStyle: {
                  fontFamily: "MicroSoft YaHei",
                  fontSize: 14,
                  fontStyle: "normal",
                },
              }
            },
            emphasis: {
              color: "#999",
              label: {
                show: !0,
                position: "right",
                textStyle: {
                  fontFamily: "MicroSoft YaHei",
                  fontSize: 14,
                  fontStyle: "normal",
                },
              }
            }
          },
          lineStyle: {
            width: 1,
            color: "#E8E8E8"
          },
          children:[tamp]
        }
      }
    }
    if(data.Category==2){
      data.symbol = 'rectangle';
      data.clickable = false;
      data.labelClick = false;
      data.symbolSize= [30, 30],
        data.itemStyle =  {
          normal: {
            color: "#6c89cb",
            borderWidth: "4",
            borderColor: "#E8E8E8",
            label: {
              show: !0,
              position: "right",
              textStyle: {
                color:'#666',
                fontFamily: "MicroSoft YaHei",
                fontSize: 14,
                fontStyle: "normal",
              },
            }
          },
          emphasis: {
            color: "#6c89cb",
            borderWidth: "2",
            borderColor: "#E8E8E8",
          }
        };
    }
  }
  //初始化树
  initTree(data){
    data.name = data.Name;
    data.labelClick = false;
    data.symbolSize = [60, 60];
    data.symbol = 'circle';
    data.itemStyle =  {
      normal: {
        color: "#40bfd5",
        borderWidth: "5",
        borderColor: "#E8E8E8",
        label: {
          show: !0,
          position: "right",
          textStyle: {
            fontFamily: "MicroSoft YaHei",
            fontSize: 14,
            fontStyle: "normal",
          },
        }
      },
      emphasis: {
        color: "#40bfd5",
        borderWidth: "3",
        borderColor: "#E8E8E8",
      }
    };
    this.getNode(this.rootDataGuQ);
  }
  getNode(data) {
    if(data.children){
      for(let i=0;i<data.children.length;i++){
        this.getNode(data.children[i]);
      }
    }
    if(data.children && data.KeyNo && data.KeyNo != this.companyId){
      data._children = data.children;
      data.children = null;
      data.symbol = 'circleCross';
    }
  }
  //股权结构图
  drawStockRight(rootDataGuQ) {
    let thiss = this;
    this.optionGuQ = {
      title : {
        text: '',
      },
      series : [
        {
          type: "tree",
          orient: "vertical",
          nodePadding: 100,
          layerPadding: 50,
          symbol:  "circle",
          roam: true,
          rootLocation: {
            "x": "48%",
            "y": "65%"
          },
          direction:"inverse",
          data: [rootDataGuQ]
        }
      ]
    };
    this.myChartGuQ.setOption(this.optionGuQ);
    this.initGuQZrender();
    this.animatieChart(this.myChartGuQ);
    let ecConfig = requireEC('echartsEC/config');
    this.myChartGuQ.on(ecConfig.EVENT.CLICK, function(e){
      if(e.data.Category==1 && e.data.KeyNo){
        if(e.data.children || e.data._children){
          thiss.troggleTree(e.data.KeyNo);
        }
      }
    });
    this.myChartGuQ.on(ecConfig.EVENT.RESTORE, function(param){
      getNode(rootDataGuQ);
      function getNode(data){
        if(data.children){
          for(let i=0;i<data.children.length;i++){
            getNode(data.children[i]);
          }
        }
        if(data.children && data.KeyNo && data.KeyNo != thiss.companyId){
          data._children = data.children;
          data.children = null;
          data.symbol = 'circleCross';
        }
      }
      this.initGuQZrender();
      this.animatieChart(this.myChartGuQ);
    });
// 	window.onresize=function(){
//    		myChartGuQ.resize();
//    	}
  }
  initGuQZrender() {
    let shapeList = this.myChartGuQ.getZrender().storage.getShapeList();
    for(let i=0;i<shapeList.length;i++){
      if(shapeList[i].clickcom){
        this.myChartGuQ.getZrender().delShape(shapeList[i].id);
      }
    }
    for(let i=0;i<shapeList.length;i++){
      if(shapeList[i]._echartsData&&shapeList[i]._echartsData._data.labelClick){
        let shape = {
          style: {
            x: shapeList[i].rotation[1]+25,
            y: shapeList[i].rotation[2],
            text: shapeList[i]._echartsData._name,
            color : '#333' ,
            textFont:'normal 13px 微软雅黑',
            lineWidth :0,
          },
          highlightStyle : {
            lineWidth :0,
            strokeColor:'rgba(0,0,0,0)',
          },
          keyNo : shapeList[i]._echartsData._data.KeyNo,
          zlevel : 1,
          z : 4,
          clickcom : true,
          clickable : true
        };
        shape.keyNo = shapeList[i]._echartsData._data.KeyNo;
        shape.zlevel = 1;
        shape.z = 4;
        shape.clickcom = true;
        shape.clickable = true;
        this.myChartGuQ.getZrender().addShape(shape);
      }
    }
  }

  troggleTree(KeyNo) {
    if(KeyNo == this.companyId){
      return;
    }
    getNode(this.rootDataGuQ);
    function getNode(data){
      if(data.KeyNo&&data.KeyNo==KeyNo){
        if(data.children){
          data._children = data.children;
          data.children = null;
          data.symbol = 'circleCross';
        }else if(data._children){
          data.children = data._children;
          data._children = null;
          data.symbol = 'circleMinus';
        }
        return;
      }
      if(data.children){
        for(let i=0;i<data.children.length;i++){
          getNode(data.children[i]);
        }
      }
    }
    this.myChartGuQ.clear();
    this.myChartGuQ.setOption(this.optionGuQ);
    this.initGuQZrender();
  }
  animatieChart(myChart) {
    let targetX;
    let targetY;
    let centerX = myChart.getZrender().getWidth()/2;
    let centerY = myChart.getZrender().getHeight()/2;
    let layer = myChart.getZrender().painter._layers[1];
    let animation = myChart.getZrender().animation;
    layer.scale = [0.2,0.2,centerX,centerY];
    layer.rotation = [0,centerX,centerY];
    layer.position = [targetX||0,targetY||0];
    myChart.getZrender().render();
    animation.animate(layer).when(400, {
      scale: [1,1,centerX,centerY]
    }).start('spline').done(function(){
      layer.scale[2] = 0;
      layer.scale[3] = 0;
    }).during(function(){
      myChart.getZrender().render();
    });
  }
*/
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enter-stockright-structure/enter-stockright-structure.component.ts